export default __webpack_public_path__ + "static/media/Profile.2ed8ba87.svg";